"use client";
import React from "react";
import RouteProvider from "./RouteProvider";
// import AuthProvider from "./AuthProvider";
import { AppWrapperProps } from "types/provider/Wrapper";
import AntdProvider from "./AntdProvider";
import I18nProvider from "./I18nProvider";
export default function Wrapper({ children, ...props }: AppWrapperProps) {
  const value = [I18nProvider, RouteProvider, AntdProvider];
  return value.reduceRight((acc, Component: any) => {
    return React.createElement(Component, props, acc);
  }, children);
}
